import type Rollbar from 'rollbar';
import { env } from '#lib';

const accessToken = env.get('VITE_ROLLBAR_ACCESS_TOKEN');
const enabled = env.isTrue('VITE_ROLLBAR_ENABLED');
const environment = env.get('VITE_ENV');

let transmit = true;
let verbose = false;

if (env.isDev() || env.isTest()) {
  transmit = false;
  verbose = true;
}

const config: Rollbar.Configuration = {
  accessToken,
  addErrorContext: true,
  autoInstrument: {
    dom: false, // See: https://github.com/rollbar/rollbar.js/issues/1399
    log: false,
    network: true,
    networkRequestBody: false,
    networkResponseBody: false,
    networkResponseHeaders: true
  },
  enabled,
  environment,
  captureUncaught: false,
  captureUnhandledRejections: false,
  maxTelemetryEvents: 50,
  replay: {
    enabled: true,
    triggers: [
      {
        type: 'occurrence',
        level: ['error', 'critical']
      }
    ]
  },
  scrubTelemetryInputs: true,
  transmit,
  verbose
};

export default config;
